import React, { useState, useEffect } from 'react';
import './Reset.password.scss';
import { useMutation } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';
import { useTranslation } from 'react-i18next';
import {Navigate, useParams} from "react-router-dom";
import {PageViewLog} from "../services/interactions/page.view";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";


function UnlockAccountComponent({ toaster, match, setUser }) {
    let { token } = useParams();
    const { t } = useTranslation(['auth']);

    const [validating, setValidating] = useState(false);
    const [validated, setValidated] = useState(false);

    const [validateToken] = useMutation(gqlSchemaLibrary.auth.mutation.unlockAccount, {
        onCompleted: ( validateResetToken ) => {
            console.log('validateUnlockAccountToken: ', validateResetToken);
            if (validateResetToken.unlockAccount) {
                AuditTrail.sendLog(PAGES.UNLOCK_ACCOUNT, {event: 'validate', action: 'validate token success', token: token});
                setValidated(true);
            } else {
                AuditTrail.sendLog(PAGES.UNLOCK_ACCOUNT, {event: 'validate', action: 'validate token error', token: token});
                setValidated(false);
            }
            setValidating(false);
        },
        onError: (error) => {
            AuditTrail.sendLog(PAGES.UNLOCK_ACCOUNT, {event: 'validate', action: 'validate token error', token: token});
        }
    });


    useEffect(() => {
        console.log('token: ', token);
        if(token){
            setValidating(true);
            validateToken({
                variables: {
                    unlockAccountToken: token
                }
            })
        }
        else{
            setValidating(false);
            setValidated(false);
        }
    }, [token, validateToken])



    return (
        <div id="ResetPassword">
            <form>
                <div className="_title">
                    <h1>
                        {validating ? t('check-token') : (validated ? t('welcome') : t('invalid-token'))}
                    </h1>
                </div>
                {
                    validating ?
                        <p className="_sent">

                        </p>
                        : (
                            !validated ?
                                <p className="_sent">
                                    <b>{t('text-invalid-token')}</b>
                                    <br />
                                    {t('detail-invalid-token')}

                                </p>
                                :
                                <>
                                    <p>
                                       Unlock Account
                                    </p>
                                    <Navigate to="/login" />
                                </>)
                }
            </form>
        </div>
    )
}

export default PageViewLog(UnlockAccountComponent);
